import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';

export const QuizLoading: React.FC = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{
        background: 'linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(219, 234, 254, 0.6) 50%, rgba(238, 242, 255, 0.8) 100%)'
      }}
    >
      <div className="text-center">
        <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <BookOpenIcon className="h-8 w-8 text-primary-600" />
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Preparazione Quiz</h3>
        <p className="text-gray-600">Caricamento domande in corso...</p>
      </div>
    </div>
  );
};
